<script>
import { Pie } from "vue-chartjs";
export default {
    name: "pie-chart",
    extends: Pie,
    props: {
        chartData: Object,
        options: {
            type: Object,
            default: () => ({
                type: "doughnut",
                responsive: true,
                maintainAspectRatio: false,
                legend: false,
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            const dataset =
                                data.datasets[tooltipItem.datasetIndex];
                            const total = dataset.data.reduce(
                                (previousValue, currentValue) =>
                                    previousValue + currentValue,
                            );
                            const currentValue =
                                dataset.data[tooltipItem.index];
                            const label = data.labels[tooltipItem.index];
                            const percentage = (
                                (currentValue / total) *
                                100
                            ).toFixed(2); // Rounded to two decimal places
                            return (
                                label +
                                ": " +
                                currentValue +
                                " (" +
                                percentage +
                                "%)"
                            );
                        },
                    },
                },
            }),
        },
    },
    mounted() {
        this.renderChart(this.chartData, this.options);
    },
};
</script>
